import React from "react";
import RequestTypeBadge from "./RequestTypeBadge";
import {
  buildSponsorScopedDetailsUrl,
  requestTypeToStatusParam,
} from "../../utils/sponsorScopedDetailsUrl";

/**
 * Additional Participating Sponsors cell: links to every other sponsor on a
 * shared assessment, each with its own Request Type role badge.
 * Link clicks stop propagation so they never trigger row-level navigation, then navigate
 * to that OTHER sponsor's own `?sponsor=&status=` instance on the SAME shared assessment
 * (`vqaRequestId` is identical across every per-sponsor row of one assessment).
 */
export default function AdditionalParticipatingSponsorsCell({
  sponsors,
  ownSponsorName,
  vqaRequestId,
  navigate,
}) {
  const others = (sponsors || []).filter(
    (s) => s?.sponsor_name && s.sponsor_name !== ownSponsorName
  );
  if (others.length === 0) {
    return <span className="text-gray-400">--</span>;
  }
  return (
    <div className="flex flex-col gap-1.5">
      {others.map((s, index) => (
        <div
          key={`${s.sponsor_name}-${index}`}
          className="flex items-center gap-1.5"
        >
          <button
            type="button"
            className="text-left hover:cursor-pointer hover:underline break-words text-indigo-600"
            onClick={(e) => {
              e.stopPropagation();
              navigate(
                buildSponsorScopedDetailsUrl(
                  `/Backend/Assessment/${vqaRequestId}/Manage`,
                  s.sponsor_name,
                  requestTypeToStatusParam(s.role)
                )
              );
            }}
          >
            {s.sponsor_name}
          </button>
          <RequestTypeBadge requestType={s.role} />
        </div>
      ))}
    </div>
  );
}
